import {baseApi} from 'core/redux/store/api';
import {API_VERSION} from 'core/helpers/env';
import {
    IEventRequest,
    IEventResponse,
    IEventsFilterResponse,
    IEventsResponse,
    IEventsResponseTransformed,
    IGetEventsFilterProps,
    IGetEventsProps,
    IRegistrationToEventProps,
    IRegistrationToEventResponse,
    IRequestIndividualTastingProps,
    IRequestIndividualTastingResponse,
} from 'modules/events/types';
import {buildHeaders} from 'core/helpers/api/headers';

const ROOT_EVENTS_PATH = '/events';
const REQUEST_INDIVIDUAL_TASTING_PATH = '/individual/request';

/* eslint-disable sort-keys */
export const eventsApiService = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getEvents: builder.query<IEventsResponseTransformed, IGetEventsProps>({
            query: ({query = ''} = {}) => {
                return {
                    url: `${API_VERSION}${ROOT_EVENTS_PATH}${query}`,
                    headers: buildHeaders({withSeo: 'list'}),
                };
            },
            transformResponse({data, pagination, seo}: IEventsResponse) {
                return {
                    data: {
                        ...data,
                        pagination,
                        seo,
                    },
                    error: null,
                };
            },
            transformErrorResponse() {
                return {
                    data: undefined,
                };
            },
        }),
        getEventsFilter: builder.query<IEventsFilterResponse, IGetEventsFilterProps>({
            query: ({query = ''} = {}) => {
                return {
                    url: `${API_VERSION}${ROOT_EVENTS_PATH}/filter${query}`,
                    headers: buildHeaders({withSeo: 'list'}),
                };
            },
        }),
        getEvent: builder.query<IEventResponse, IEventRequest>({
            query: (query) => {
                return {
                    url: `${API_VERSION}/events/${query.id}`,
                    headers: buildHeaders({withSeo: 'detail'}),
                };
            },
            transformResponse: (response: IEventResponse) => {
                return response;
            },
        }),
        registrationToEvent: builder.mutation<IRegistrationToEventResponse, IRegistrationToEventProps>({
            query: ({id, data}) => {
                return {
                    body: data,
                    method: 'POST',
                    url: `${API_VERSION}${ROOT_EVENTS_PATH}/${id}/request`,
                };
            },
            transformResponse: (_, meta): IRequestIndividualTastingResponse => {
                return {
                    ok: Boolean(meta?.response?.ok),
                };
            },
        }),
        requestIndividualTasting: builder.mutation<IRequestIndividualTastingResponse, IRequestIndividualTastingProps>({
            query: (data) => {
                return {
                    body: data,
                    method: 'POST',
                    url: `${API_VERSION}${ROOT_EVENTS_PATH}${REQUEST_INDIVIDUAL_TASTING_PATH}`,
                };
            },
            transformResponse: (_, meta): IRequestIndividualTastingResponse => {
                return {
                    ok: Boolean(meta?.response?.ok),
                };
            },
        }),
    }),
});

export const {
    useGetEventQuery,
    useGetEventsQuery,
    useGetEventsFilterQuery,
    useRegistrationToEventMutation,
    useRequestIndividualTastingMutation,
    util: {getRunningQueriesThunk},
} = eventsApiService;

export const {getEvents, getEvent, getEventsFilter} = eventsApiService.endpoints;
